import { useEffect, useState } from "react";
import InputData from "./InputData";
import CheckBox from "./CheckBox";
import ButtonIconH from "./ButtonIconH";
import Dropdown from "./Dropdown";
import { post } from "../js/post";
import { focusElement, selectedOptic, userData } from "../js/utils";
import { useOptometrists } from "../hooks/useOptometrists";
import WacomSignaturePopup from "./WacomSignaturePopup";

export function LCConsent({
  patientData,
  createPopupQuestion,
  removePopupQuestion,
  onClose,
}) {
  const optometristList = [{ id: "", text: "" }, ...useOptometrists()];
  const [data, setData] = useState({
    agente: "",
    nombreResponsable: "",
    dniResponsable: "",
    miopia: false,
    hipermetropia: false,
    astigmatismo: false,
    otros: false,
  });
  const [wacomPopup, setWacomPopup] = useState(false);

  // console.log("data: ", data);

  const generateConsent = async (signature) => {
    const response = await post(
      "/support-extra/gestionDocumental/GenerarDocumentoLC.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idPaciente: patientData.id,
        firma: signature,
        ...data,
      },
    );
    // console.log(
      // "GENERANDO: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // idPaciente: patientData.id,
        // firma: signature,
        // ...data,
      // },
      // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `LC_${patientData.name}.pdf`;
      a.click();
      createPopupQuestion(
        "Consentimiento LC generado satisfactoriamente.",
        () => {
          onClose();
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  };

  const checkOptometrist = () => {
    if (data.agente === "") {
      createPopupQuestion(
        "Seleccione un optometrista.",
        () => {
          removePopupQuestion();
          focusElement(200);
        },
        null,
        "Entendido",
      );
      return false;
    }
    return true;
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      nombreResponsable: patientData.name,
      dniResponsable: patientData.nif,
    }));
  }, [patientData]);

  useEffect(() => {
    focusElement(200);
  }, []);

  return (
    <div className="popup-container">
      {wacomPopup && (
        <WacomSignaturePopup
          onSave={async (signature) => {
            setWacomPopup(false);
            await generateConsent(signature);
          }}
          onClose={() => {
            setWacomPopup(false);
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Consentimiento LC</span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              onClose(data);
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className={`tab-content ap-content`}
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="container-panel">
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                  }}
                >
                  <div
                    className="opt-table-tooltip grid-5"
                    id="gdpr-consent-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Optometrista
                    </div>
                    <div className="cell cell-label">
                      <Dropdown
                        tabIndex={200}
                        optionList={optometristList}
                        size={0}
                        op={data.agente}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            agente: e.text,
                          }));
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      DNI responsable
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={201}
                        type="type-only-charnumbers"
                        size={0}
                        maxLength={12}
                        input={data.dniResponsable}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            dniResponsable: e,
                          }));
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Paciente
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={-1}
                        type="type-only-charnumbers"
                        size={0}
                        input={patientData.name}
                        inactive={true}
                        onChange={() => {}}
                        onClick={() => {}}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Responsable
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={202}
                        type="type-alpha"
                        size={0}
                        input={data.nombreResponsable}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            nombreResponsable: e,
                          }));
                        }}
                      ></InputData>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <div
                      className="opt-table-tooltip grid-11"
                      id="lc-consents-grid"
                    >
                      <div className="cell cell-label cell-start-content">
                        Miopía
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={203}
                          active={data.miopia}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              miopia: !prev.miopia,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Hipermetropía
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={204}
                          active={data.hipermetropia}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              hipermetropia: !prev.hipermetropia,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Astigmatismo
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={205}
                          active={data.astigmatismo}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              astigmatismo: !prev.astigmatismo,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Otros
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={206}
                          active={data.otros}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              otros: !prev.otros,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="popup-buttons"
                style={{ justifyContent: "center", gap: 20 }}
              >
                <ButtonIconH
                  text="Firmar"
                  small={true}
                  onClick={() => {
                    if (checkOptometrist()) setWacomPopup(true);
                  }}
                ></ButtonIconH>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
